/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ModelContract } from 'account-client'
import styles from './index.less'
import { Replicable } from '@/components/Replicable'
import { BuyerType } from '@/pages/contract/features/BuyerType'
import { TBuyerType } from '@/pages/contract/interface'
import { timeFormatter } from '@/utils/timeFormatter'

export function ContractInfo(
  props: React.PropsWithoutRef<{
    contract: ModelContract
  }>,
) {
  const { contract } = props
  const { id, tags, creator, commencingOn, buyerName, buyerType } = contract
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <span className={styles.label}>{t('Contract Tags')}</span>
        <strong>{tags}</strong>
      </div>
      <div className={styles.item}>
        <span className={styles.label}>{t('Contract ID')}</span>
        <Replicable value={id}>{id}</Replicable>
      </div>
      <div className={styles.item}>
        <span className={styles.label}>{buyerType === TBuyerType.E ? t('Company Name') : t('Full Name')}</span>
        <span>{buyerName}</span>
      </div>
      <div className={styles.item}>
        <span className={styles.label}>{t('Type')}</span>
        <BuyerType buyerType={buyerType as TBuyerType} />
      </div>
      <div className={styles.item}>
        <span className={styles.label}>{t('Creator')}</span>
        <span>{creator}</span>
      </div>
      <div className={styles.item}>
        <span className={styles.label}>{t('Signing Date')}</span>
        <span>{timeFormatter.format(commencingOn)}</span>
      </div>
    </div>
  )
}
